import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import classNames from "classnames";
const Modal = ( {
  open,
  modalTitle,
  modalDescription,
  closeHandler,
  children,
  modalWidth = "sm:max-w-lg",
}) => {
  const cancelButtonRef = useRef(null);
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        auto-reopen="true"
        className="fixed inset-0 z-[1400] overflow-y-auto"
        initialFocus={cancelButtonRef}
        open={open}
        onClose={closeHandler}
      >
        <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
          </Transition.Child>

          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              className={classNames(
                modalWidth,
                "inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-middle transition-all transform rounded-lg shadow-xl bg-white sm:my-8 sm:align-middle sm:w-full sm:p-6"
              )}
            >
              <div className="mb-2 text-center">
                <h3 className="font-medium text-gray-900 text-md">
                  {modalTitle}
                </h3>
                <span className="text-xs">{modalDescription}</span>
              </div>
              <div>{children}</div>
              <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button
                  type="button"
                  className="justify-center hidden w-full px-4 py-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm"
                  ref={cancelButtonRef}
                />
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default Modal;